/**
 * ContactInfo Component
 * Displays company contact information
 */

import React from 'react';
import { ContactGlobal } from '@/types/contactType';

interface ContactInfoProps {
  contactInfo: ContactGlobal | null;
  loading: boolean;
  error: string | null;
}

export default function ContactInfo({ contactInfo, loading, error }: ContactInfoProps) {
  if (loading) {
    return (
      <div className="space-y-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-300 rounded mb-2"></div>
          <div className="h-4 bg-gray-300 rounded mb-4"></div>
          <div className="h-4 bg-gray-300 rounded mb-4"></div>
          <div className="h-4 bg-gray-300 rounded mb-4"></div>
          <div className="h-4 bg-gray-300 rounded"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-6">
        <div className="text-red-500 text-center">
          {error}
        </div>
      </div>
    );
  }

  if (!contactInfo) {
    return (
      <div className="space-y-6">
        <div className="text-gray-500 text-center">
          Chưa có thông tin liên hệ
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <p className="text-lg font-semibold text-gray-900 mb-2">
          CÔNG TY CỔ PHẦN ĐẦU TƯ KIẾN TẠO XANH GROUP
        </p>
        {contactInfo.address && (
          <p className="text-gray-600">
            Địa chỉ: {contactInfo.address}
          </p>
        )}
      </div>

      {contactInfo.website && (
        <div>
          <p className="text-gray-600">
            <span className="font-medium">Website:</span>{" "}
            <a
              href={contactInfo.website.startsWith('http') ? contactInfo.website : `https://${contactInfo.website}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 hover:text-green-700 transition-colors"
            >
              {contactInfo.website}
            </a>
          </p>
        </div>
      )}

      {contactInfo.phone && (
        <div>
          <p className="text-gray-600">
            <span className="font-medium">Điện thoại:</span>{" "}
            <a
              href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
              className="text-green-600 hover:text-green-700 transition-colors"
            >
              {contactInfo.phone}
            </a>
          </p>
        </div>
      )}

      {contactInfo.email && (
        <div>
          <p className="text-gray-600">
            <span className="font-medium">Email:</span>{" "}
            <a
              href={`mailto:${contactInfo.email}`}
              className="text-green-600 hover:text-green-700 transition-colors"
            >
              {contactInfo.email}
            </a>
          </p>
        </div>
      )}
    </div>
  );
}